export default __webpack_public_path__ + "static/media/diprom.bed8c1b3.png";